import $ from 'jquery'
import Splide from '@splidejs/splide'
import {Offcanvas} from 'bootstrap';

const object = vnObject

$('.js-desc-more').on('click', function () {
    const button = $(this)
    const button_parent = $('.js-desc')

    if (button_parent.hasClass('description--active')) {
        button.html(object.readMore + '<i class="vn-icons-arrow_downward"></i>')
    } else {
        button.html(object.readLess + '<i class="vn-icons-arrow_downward"></i>')
    }

    button.toggleClass('s-product__description--content--more--active')
    button_parent.toggleClass('description--active')
})

$('.js-products-slider').each(function () {
    var $this = $(this);
    var splideInstance = new Splide($this[0], {
        pagination: false,
        arrows: false,
        perPage: 3,
        breakpoints: {
            991: {
                perPage: 2,
                padding: {right: '5%'},
            },
            719: {
                perPage: 1,
                padding: {right: '5%'},
            }
        }
    });

    splideInstance.mount();
});

$('form.cart').on('submit', function (e) {
    let $form = $(this);

    // ID du produit ou de la variation
    let variationId = $form.find('input[name="variation_id"]').val();
    let productId = variationId || $form.find('button[name="add-to-cart"]').val();

    // 🔄 Récupération de tous les attributs sélectionnés dynamiquement
    let attributes = {};
    $form.find('select[name^="attribute_"]').each(function () {
        let name = $(this).attr('name'); // ex: attribute_pa_glass_color
        console.log("iIC")
        let label = $(this).closest('tr').find('label').text().trim(); // essaie de trouver le label si possible
        if (!label) {
            // si pas de label, on nettoie le name pour obtenir un nom lisible
            label = name.replace('attribute_pa_', '').replace('attribute_', '').replace(/_/g, ' ');
            label = label.charAt(0).toUpperCase() + label.slice(1);
        }
        let value = $(this).find('option:selected').text();
        if (value) {
            attributes[label] = value;
        }
    });

    // Quantité
    let quantity = $form.find('input.qty').val() || 1;

    // Prix
    let price = $('.js-product-price').data('total');

    // Image
    let imageSelector = window.innerWidth < 992 ? '.js-mobile-thumb img' : '.js-desk-thumb img';
    let $image = $(imageSelector).first();
    let imageHtml = $image.length ? $image.prop('outerHTML') : '';

    // Stockage
    let productData = {id: productId, attributes, quantity, price, imageHtml};
    sessionStorage.setItem('last_added_product', JSON.stringify(productData));
});


// Quand une variation est trouvée
$('form.variations_form').on('found_variation', function (event, variation) {
    if (!variation) return;

    var full = variation.image.full_src;
    var src = variation.image.src || full;
    var sizes = variation.image.sizes || '';

    const $jsMobileThumb = $('.js-mobile-thumb');
    var $mobileImg = $jsMobileThumb.find('img');
    var $mobileImgSource = $jsMobileThumb.find('source');
    $mobileImgSource.attr('srcset', '')
    $mobileImg.attr('src', src)
        .attr('data-src', full)
        .attr('data-large_image', full)
        .attr('srcset', '')
        .attr('sizes', sizes);

    // On récupère les attributs choisis dans le formulaire
    var attributes = variation.attributes;

    // Pour chaque item qui a un data-base-url
    $('.js-variable-item').each(function () {
        var baseUrl = $(this).data('base-url');
        if (!baseUrl) return;

        // Construire la query string à partir des attributs sélectionnés
        var queryParts = [];
        $.each(attributes, function (attrName, attrValue) {
            if (attrValue) {
                // WooCommerce stocke les attributs avec "attribute_" devant
                var cleanName = attrName.replace(/^attribute_/, '');
                queryParts.push(encodeURIComponent(cleanName) + '=' + encodeURIComponent(attrValue));
            }
        });

        var newUrl = baseUrl;
        if (queryParts.length > 0) {
            newUrl += '?attribute_' + queryParts.join('&');
        }

        // Mise à jour du lien
        $(this).attr('href', newUrl);
    });
});

var $mainGalleryLink = $('.woocommerce-product-gallery__image a').first();
var originalSrc = $mainGalleryLink.attr('href');


$(document.body).on('reset_data', function () {
    // Remettre dans ton thumbnail mobile
    $('.js-mobile-thumb').find('img').attr('src', originalSrc);
});

var deskContainer = $('.woocommerce-product-gallery__image')
var deskHeight = deskContainer.height() == -1 ? '900px' : deskContainer.height()
// Applique la hauteur fixe au conteneur des images
deskContainer.css({
    'height': deskHeight,
});

var mobileContainer = $('.js-mobile-thumb')
var mobileHeight = mobileContainer.height() == -1 ? '330px' : mobileContainer.height()
mobileContainer.css({
    'height': mobileHeight,
});


var $priceBox = $('.js-product-price');

var $cartForm = $('form.cart').first();
var $qty = $cartForm.find('input.qty').first();
if (!$qty.length) $qty = $('input.qty').first(); // fallback

var $variationForm = $('form.variations_form');

// Parse un prix depuis un texte (gère 1.234,56 et 1,234.56 et 1234.56 et 1234,56)
function parsePrice(text) {
    if (!text && text !== 0) return 0;
    text = String(text).replace(/\s+/g, '').trim();
    var m = text.match(/-?\d[\d.,]*/);
    if (!m) return 0;
    var n = m[0];
    if (n.indexOf('.') > -1 && n.indexOf(',') > -1) {
        // si les deux existent, déterminer lequel est la décimale selon l'ordre
        if (n.indexOf('.') < n.indexOf(',')) n = n.replace(/\./g, '').replace(',', '.');
        else n = n.replace(/,/g, '');
    } else if (n.indexOf(',') > -1) {
        n = n.replace(',', '.');
    }
    return parseFloat(n) || 0;
}

function setDataTotalValue(value) {
    // valeur en nombre avec deux décimales (utilisez un format différent si vous le souhaitez)
    $priceBox.attr('data-total', (Math.round((value + Number.EPSILON) * 100) / 100).toFixed(2));
}

// prix unitaire de base (pour produit simple ou prix par défaut)
var baseUnitPrice = parsePrice($priceBox.text());
// prix unitaire courant (change si variation sélectionnée)
var currentUnitPrice = baseUnitPrice;

function qtyValue() {
    var q = ($cartForm.find('input.qty').val() || $qty.val()) || 1;
    q = parseFloat(q);
    return (isNaN(q) || q < 1) ? 1 : q;
}

function updateTotal() {
    var qty = qtyValue();
    var total = (currentUnitPrice || 0) * qty;
    setDataTotalValue(total);
}

// Observer sur le priceBox pour capter les changements de prix faits par d'autres scripts (utile pour produit simple)
try {
    var mo = new MutationObserver(function () {
        var newBase = parsePrice($priceBox.text());
        if (newBase && newBase !== baseUnitPrice) {
            baseUnitPrice = newBase;
            // si aucune variation sélectionnée, on met à jour le prix courant aussi
            if (!$variationForm.length || !$variationForm.data('variation-selected')) {
                currentUnitPrice = baseUnitPrice;
                updateTotal();
            }
        }
    });
    mo.observe($priceBox[0], {childList: true, subtree: true, characterData: true});
} catch (e) {
    // MutationObserver non supporté → on se repose sur les événements classiques
}

// --- Gestion produit variable (si présent) ---
if ($variationForm.length) {
    $variationForm.on('found_variation', function (e, variation) {
        $variationForm.data('variation-selected', true);
        // variation.display_price est numérique, variation.price_html est le html formaté
        var displayPrice = object.isPro ? parseFloat(variation.display_pro_price) : parseFloat(variation.display_price)
        currentUnitPrice = displayPrice || parsePrice(variation.price_html) || baseUnitPrice;
        if (variation.price_html) $priceBox.html(variation.price_html);
        updateTotal();
    });
}

// --- Écoute du changement de quantité (fonctionne pour les deux cas) ---
$(document).on('input change', 'input.qty', function () {
    updateTotal();
});

// initial
updateTotal();


$('.variable-item-span-color').each(function () {
    // Récupère la couleur de fond calculée par le navigateur
    var bg = $(this).css('background-color');

    // Selon les navigateurs, le blanc est souvent "rgb(255, 255, 255)"
    // ou "rgba(255, 255, 255, 1)"
    if (bg === 'rgb(255, 255, 255)' || bg === 'rgba(255, 255, 255, 1)' || bg === '#FFF') {
        $(this).addClass('white');
    }

    if (bg === 'rgb(0, 0, 0)' || bg === 'rgba(0, 0, 0, 1)' || bg === '#000') {
        $(this).addClass('black');
    }
});

$('button.vn-pill').on('click', function (e) {
    const btn = $(this);
    e.preventDefault();

    const form = btn.closest('.variations_form');
    const attr = btn.data('attribute');
    const name = btn.data('name');
    let value = btn.data('value');
    const $galleryImage = $('.gallery-thumbnails')

    if (btn.hasClass('vn-clear')) {
        $galleryImage.show()
        value = btn.data('default')
    } else if(!form.length || !attr || !value){
        return;
    } else {
        $galleryImage.hide()
    }

    const $select = form.find('select[name="attribute_' + attr + '"]');

    if ($select.length) {
        $select.val(value);

        $select[0].dispatchEvent(new Event('change', {bubbles: true}));
        $select.trigger('change');

        btn.addClass('is-active').siblings('[data-attribute="' + attr + '"]').removeClass('is-active');

        form.trigger('woocommerce_variation_select_change');
        form.trigger('check_variations');
        btn.closest('tr').find('th.label').attr('data-attribute', name);
        form.trigger('woocommerce_variation_has_changed');
    }
});

